import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

import Loader from '../../HelperComponents/Loader/Loader';
import { getReturnDispatchPendingSuppliers } from '../../../actions/returnDispatchesActions';
import { formatPrice } from '../../../helpers/functions';

import './WaitingReturnDispatchSuppliers.scss';

class WaitingReturnDispatchSuppliers extends Component {
    state = {
        loading: true,
    };

    componentDidMount = () => {
        this.props.getReturnDispatchPendingSuppliers().then(res => {
            if (res.payload && res.payload.status && res.payload.status === 200) {
                this.setState({ loading: false });
            } else {
                this.setState({ loading: false });
            }
        });
    };

    handleRowClick = (item) => {
        const { history } = this.props;
        history.push({
            pathname: '/admin/new-return-dispatch',
            state: {
                supplier_id: item.supplier_id,
                supplier_name: item.supplier_name,
            },
        });
    };

    render() {
        const { loading } = this.state;
        const { pending_suppliers } = this.props;

        if (loading) return <Loader />;

        return (
            <div className="waiting_return_dispatch_block">
                <div className="waiting_return_dispatch">
                    <div className="title">Ожидают выдачи</div>
                    {pending_suppliers && pending_suppliers.length ? (
                        <div className="waiting_return_dispatch_table">
                            <div className="table_container transactions_columns">
                                <div className="table_header">
                                    <div className="table_row">
                                        <div className="row_item">Поставщик</div>
                                        <div className="row_item">Количество</div>
                                        <div className="row_item">Сумма</div>
                                    </div>
                                </div>
                                <div className="table_body">
                                    {pending_suppliers.map(item => (
                                        <div
                                            className="table_row"
                                            onClick={() => this.handleRowClick(item)}
                                            key={item.supplier_id}
                                        >
                                            <div className="row_item">{item.supplier_name}</div>
                                            <div className="row_item">{item.items_count}</div>
                                            <div className="row_item">{formatPrice(item.total_sum)}</div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ) : (
                        <p>Ожидающих выдачи нет</p>
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ return_dispatches }) => ({
    pending_suppliers: return_dispatches.pending_suppliers,
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getReturnDispatchPendingSuppliers,
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WaitingReturnDispatchSuppliers));
